export enum ControlModuleId {
	ArchiveJobs = '790ad905-1c5f-49a0-8c6f-1e55f96eab3a',
	AssistedReview = 'eab5e0c8-b0b7-4d53-894a-835a89261e1d',
	Coding = '1eef974b-2c80-43d1-835d-de165bffe4b1',
	Review = '4cefe1db-708a-471c-b6bc-9136f16141ff',
	DeleteDocs = 'b7fb86c3-4ffc-41ed-b40d-021f622ab2fc',
	DocumentId = 'edccb61c-b999-4afb-956f-d1cc5a808c06',
	Export = '866addf9-e534-41aa-894d-2ad116fd1930',
	ExportOperations = 'f1946000-5e8b-4b53-ba72-27821b430a59',
	FieldQuickLinks = 'fb5bab12-10a1-48e2-8d0b-a6b9b4488698',
	Fields = '5f863049-1a5f-4df5-ba0f-71b0ea533449',
	FilterQuickLinks = '6a92f1a6-ab75-49bd-9f35-70b28d39c318',
	Filters = 'c6fa559c-e13c-4912-a064-5b60b4c4f531',
	FolderQuickLinks = '4d738776-44c8-4fea-8e9a-a6f332d0d2be',
	Folders = 'c1e68f30-5b78-4437-b5cb-e2bdd3c022e1',
	General = '1b7c6e96-01a4-47e2-ad39-c277db23b467',
	Groups = 'a6a248d7-f2a9-4656-b0aa-791f40b5997d',
	Metadata = '196a20ca-033f-4e5e-aa68-484a2cdfa16b',
	MultiDocEdit = '9d3644a9-1298-4e34-be4d-d61a3e4342a0',
	Options = 'a2ef751e-1a2e-41b2-85ab-073217ee2776',
	Processing = 'ff5ce79b-c513-4510-ac4c-a1dd27c8fa69',
	Productions = '112f90a5-8649-4f6b-97a4-ad41d8d78670',
	ReviewSet = '686a0038-8aa8-48bd-ac45-6b588702bd32',
	SearchQuickLinks = 'f9549652-2282-41c8-b458-a5a2e644efb9',
	ShowSearchesFor = '9da61da9-3275-4be9-b3ea-88f072e94dc7',
	Sort = '29b3346f-84f8-4839-bf86-1bcacd78a6bb'
}
